import(/* webpackMode: "eager" */ "/home/runner/work/MONADATY/MONADATY/app/global-error.tsx");
